export default __webpack_public_path__ + "static/Couture-Regular-c6c52941c37d21db54c8dd0627a29dc9.otf";